// extracted by mini-css-extract-plugin
export default {"feedContainer":"Feed_feedContainer__FTcz8"};